import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { PrimaryButton, GhostButton, Field, inputCls } from "@/components/common";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { KeyRound, Eye, EyeOff, Loader2 } from "lucide-react";

export default function ChangePasswordModal({ open, onOpenChange }) {
  const [form, setForm] = useState({ current: "", next: "", confirm: "" });
  const [show, setShow] = useState({ c: false, n: false, k: false });
  const [loading, setLoading] = useState(false);

  const reset = () => setForm({ current: "", next: "", confirm: "" });

  const submit = async (e) => {
    e.preventDefault();
    if (!form.current || !form.next) { toast.error("Completa los campos"); return; }
    if (form.next.length < 8) { toast.error("La nueva clave debe tener al menos 8 caracteres"); return; }
    if (form.next !== form.confirm) { toast.error("Las contraseñas nuevas no coinciden"); return; }
    setLoading(true);
    try {
      await api.post("/auth/change-password", { current_password: form.current, new_password: form.next });
      toast.success("Contraseña actualizada");
      reset();
      onOpenChange(false);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "No se pudo cambiar la contraseña");
    } finally { setLoading(false); }
  };

  const PwdInput = ({ label, valueKey, showKey, testid }) => (
    <Field label={label}>
      <div className="relative">
        <input
          data-testid={testid}
          type={show[showKey] ? "text" : "password"}
          required
          value={form[valueKey]}
          onChange={e=>setForm({...form, [valueKey]: e.target.value})}
          className={`${inputCls} pr-10`}
          autoComplete="new-password"
        />
        <button
          type="button"
          onClick={()=>setShow({...show, [showKey]: !show[showKey]})}
          className="absolute right-3 top-1/2 -translate-y-1/2 text-[#6B7280] hover:text-[#F5F5F7] transition-colors"
          aria-label="Ver contraseña"
        >
          {show[showKey] ? <EyeOff className="w-4 h-4"/> : <Eye className="w-4 h-4"/>}
        </button>
      </div>
    </Field>
  );

  return (
    <Dialog open={open} onOpenChange={(o)=>{ if (!o) reset(); onOpenChange(o); }}>
      <DialogContent className="bg-[#15171E] border-[#262A33] text-[#F5F5F7] max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2" style={{ fontFamily: "Manrope, sans-serif" }}>
            <KeyRound className="w-4 h-4 text-[#F97316]"/> Cambiar contraseña
          </DialogTitle>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <PwdInput label="Contraseña actual" valueKey="current" showKey="c" testid="current-password-input"/>
          <PwdInput label="Nueva contraseña (mín. 8 caracteres)" valueKey="next" showKey="n" testid="new-password-input"/>
          <PwdInput label="Confirma la nueva contraseña" valueKey="confirm" showKey="k" testid="confirm-password-input"/>
          <DialogFooter>
            <GhostButton type="button" onClick={()=>onOpenChange(false)}>Cancelar</GhostButton>
            <PrimaryButton type="submit" data-testid="save-password-btn" disabled={loading}>
              {loading ? <Loader2 className="w-4 h-4 animate-spin"/> : <KeyRound className="w-4 h-4"/>} Guardar
            </PrimaryButton>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
